import React from 'react'
import {isEmpty} from 'lodash'
import {Redirect} from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'
import ActionCompareArrows from 'material-ui-legacy/svg-icons/action/compare-arrows'
import ActionCheckCircle from 'material-ui-legacy/svg-icons/action/check-circle'
import {deepOrange500, lightGreenA700} from 'material-ui-legacy/styles/colors'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import ClientForm from './ClientForm'

import Resource from '../../stores/resource'
const ClientStore = Resource('clients')

class EditClient extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      client: (this.props.client || {}),
      changed: false,
      saved: false,
      error: '',
      snackbarMessage: ''
    }
  }

  _save = (attributes) => {
    ClientStore.update(this.state.client.id, attributes)
    .then((result) => {
      this.setState({
        saved: true,
        changed: false,
        error: '',
        savedClient: result.data.data,
        snackbarMessage: `Client "${attributes.name}" saved!`
      },
      () => {
        if (this.props.savedCallback) {
          this.props.savedCallback(this.state.savedClient)
        }
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _changed = (didChange) => this.setState({changed: didChange, saved: false})

  _closeErrorDialog = () => this.setState({error: ''})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect}/>

    const client = (isEmpty(this.state.client)) ? null : this.state.client

    const changed = this.state.changed
    const saved = this.state.saved

    return (
      <section>
        <ClientForm
          formTitle={
            <span>
              {client.attributes.name}&nbsp;
              {changed && <ActionCompareArrows color={deepOrange500}/>}
              {saved && <ActionCheckCircle color={lightGreenA700}/>}
            </span>
          }
          client={client}
          changedCallback={this._changed}
          submitCallback={this._save}
          cancelCallback={() => this._redirectTo("/clients")}
        />

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't save your changes">
          <p>
            The client <strong>{client.name}</strong> remains unchanged.
          </p>
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditClient



// WEBPACK FOOTER //
// ./src/components/Clients/EditClient.jsx